<template>
  <div class="service-client">
    <div>
      <div v-if="client && app_mode === 'advanced'">
        <h3 class="my-2">Avaliação do cliente</h3>
        <div class="client-evaluation">
          <table class="yeep-table normal-text">
            <tr>
              <td style="width: 33%">
                <v-icon size="30" color="warning">mdi-star</v-icon
                ><span style="font-size: 18px; margin-top: 2px">/ {{ evaluation ? evaluation.service_note : '-' }}</span
                ><br />
                <span style="font-size: 14px">Serviço</span>
              </td>
              <td style="width: 33%">
                <v-icon size="30" color="warning">mdi-star</v-icon
                ><span style="font-size: 18px; margin-top: 2px">/ {{ evaluation ? evaluation.attendance_note : '-' }}</span
                ><br />
                <span style="font-size: 14px">Atendimento</span>
              </td>
              <td style="width: 33%">
                <v-icon size="30" color="warning">mdi-star</v-icon
                ><span style="font-size: 18px; margin-top: 2px">/ {{ evaluation ? evaluation.indication_note : '-' }}</span
                ><br />
                <span style="font-size: 14px">Indicação</span>
              </td>
            </tr>
            <tr>
              <td colspan="3" style="background-color: rgb(219, 219, 219)">Observação</td>
            </tr>
            <tr>
              <td class="text-left" colspan="3">
                <small>{{
                  evaluation
                    ? evaluation.observation
                      ? evaluation.observation
                      : 'Cliente não deixou observações...'
                    : 'Aguardando avaliação do cliente...'
                }}</small>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <h3 v-if="app_mode === 'advanced'" class="my-2 mt-5">Cliente</h3>
      <table v-if="client && app_mode === 'advanced'" class="yeep-table">
        <tr>
          <td colspan="2" class="text-left">
            <v-list-item class="px-0">
              <v-list-item-avatar>
                <v-icon class="grey lighten-1" dark>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content v-if="client">
                <v-list-item-title style="font-size: 19px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100px"
                  ><b>{{ client.name }}</b></v-list-item-title
                >
                <v-list-item-subtitle v-if="client.profession"
                  ><b>{{ client.profession }}</b></v-list-item-subtitle
                >
                <v-list-item-subtitle
                  >{{ client.type }} - {{ client.client_classification ? client.client_classification.description : '' }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </td>
        </tr>
        <tr>
          <td>SERVIÇOS</td>
          <td>{{ client.service_orders_count }}</td>
        </tr>
        <tr>
          <td>Cadastrado em</td>
          <td>{{ new Date(client.created_at).toLocaleDateString() }}</td>
        </tr>
        <tr>
          <td>Aniversário em</td>
          <td>
            {{
              new Date(new Date(client.birthdate).getTime() + Math.abs(new Date(client.birthdate).getTimezoneOffset() * 60000)).toLocaleDateString(
                'pt-BR',
                { day: 'numeric', month: 'short' }
              )
            }}
          </td>
        </tr>
        <tr>
          <td colspan="2" style="background-color: #dbdbdb">Contato</td>
        </tr>
        <tr>
          <td>{{ client.phone }}</td>
          <td @click="openWhatsapp(client.phone)" style="background-color: #48b38b">
            <v-icon color="white">mdi-whatsapp</v-icon>
          </td>
        </tr>
        <!-- <tr>
        <td colspan="2" style="background-color: #dbdbdb">
          Endereços
        </td>
      </tr>
      <tr v-for="address in client.client_addresses" :key="address.id">
        <td>{{ address.description }}</td>
        <td @click="openMaps(address.coordinates)" style="background-color: #4A80F5">
          <v-icon color="white">mdi-google-maps</v-icon>
        </td>
      </tr> -->
      </table>
      <div v-if="status !== 'finished' && status !== 'canceled' && app_mode === 'advanced'" class="box mt-3">
        <div @click="handleOpenAddClient" class="add">ESPECIFICAR CLIENTE</div>
      </div>
    </div>
    <div>
      <h3 v-if="app_mode === 'advanced'" class="my-2 mt-5">Veículo</h3>
      <table v-if="vehicle" class="yeep-table">
        <tr>
          <td colspan="2">{{ vehicle.description }}</td>
        </tr>
        <tr>
          <td colspan="2" class="py-3">
            <div v-if="!vehicle.vehicle_plate_photo_url" class="plate-content">
              <div class="plate">
                <span>{{ vehicle_plate }}</span>
              </div>
            </div>
            <img v-else :src="vehicle.vehicle_plate_photo_url" height="95px" />
          </td>
        </tr>
        <tr>
          <td>
            <div v-if="vehicle.vehicle_brand" :style="`background-image: url('${vehicle.vehicle_brand.logo_url}');`" class="vehicle-brand"></div>
          </td>
          <td>
            <b>{{ vehicle.description }}</b>
          </td>
        </tr>
        <tr>
          <td>
            ANO: <b>{{ vehicle.year }}</b>
          </td>
          <td>
            MODELO: <b>{{ vehicle.year_model }}</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>{{ vehicle.color }}</b>
          </td>
          <td>
            <b>{{ vehicle.fuel }}</b>
          </td>
        </tr>
        <tr>
          <td>
            Cilindrada: <br />
            <b>{{ vehicle.engine_cc }}</b>
          </td>
          <td>
            Potencia: <b>{{ vehicle.engine_cv }}</b>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            Importado: <b>{{ vehicle.imported == 0 ? 'Não' : 'Sim' }}</b>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            Chassi: <b>{{ vehicle.chassi }}</b>
          </td>
        </tr>
      </table>
      <small v-if="vehicle">*Confirme informações com o cliente.</small>
      <div v-if="status !== 'finished' && status !== 'canceled'" class="box mt-3">
        <v-btn v-if="vehicle" @click="isModalEditVehicleOpen = true" outlined color="warning" dark large elevation="0" block>
          <v-icon class="mr-2">mdi-car-cog</v-icon>
          <span>EDITAR ESTE VEÍCULO</span>
        </v-btn>
        <v-btn
          v-if="vehicle"
          class="mt-2"
          @click="isModalManageVehicleOpen = true"
          outlined
          color="primary"
          dark
          large
          elevation="0"
          block
        >
          <v-icon class="mr-2">mdi-car-multiple</v-icon>
          <span>SELECIONAR OUTRO VEÍCULO</span>
        </v-btn>
        <div v-if="!vehicle" @click="handleOpenAddVehicle" class="box mb-3">
          <div class="add">ESPECIFICAR VEÍCULO</div>
        </div>
      </div>

      <ModalManageClient :isActive="isModalManageClientOpen" @close="closeModalManageClient" />

      <ModalManageVehicle :isActive="isModalManageVehicleOpen" :client="client" @close="closeModalManageVehicle" />

      <ModalEditVehicle v-if="vehicle" :isActive="isModalEditVehicleOpen" :vehicle="vehicle" @close="closeModalEditVehicle" />
    </div>
  </div>
</template>

<script>
import ModalManageClient from './Dialogs/ModalManageClient';
import ModalManageVehicle from './Dialogs/ModalManageVehicle';
import ModalEditVehicle from './Dialogs/ModalEditVehicle';

export default {
  name: 'Client',
  components: {
    ModalManageClient,
    ModalManageVehicle,
    ModalEditVehicle
  },
  data() {
    return {
      isModalManageClientOpen: false,
      isModalManageVehicleOpen: false,
      isModalEditVehicleOpen: false,
    };
  },
  mounted() {
    this.$store.dispatch('ClientClassification/getClientClassifications');
  },
  computed: {
    app_mode() {
      return localStorage.getItem('app_mode') || 'advanced';
    },
    client() {
      return this.$store.getters['ServiceOrder/client'];
    },
    vehicle() {
      return this.$store.getters['ServiceOrder/vehicle'];
    },
    evaluation() {
      return this.$store.getters['ServiceOrder/evaluation'];
    },
    vehicle_plate() {
      if (!this.vehicle) {
        return '';
      }

      const firstPart = this.vehicle.vehicle_plate.slice(0, 3);
      const secondPart = this.vehicle.vehicle_plate.substr(-4);
      return `${firstPart}-${secondPart}`;
    },
    status() {
      return this.$store.getters['ServiceOrder/status'];
    }
  },
  methods: {
    closeModalManageClient(client) {
      if (client) {
        this.saveClient(client);
        this.$emit('update-vehicle-plate-by-photo', client);
      }

      this.isModalManageClientOpen = false;
    },
    closeModalManageVehicle(vehicle) {
      if (vehicle) {
        this.saveVehicle(vehicle);
      }

      this.isModalManageVehicleOpen = false;
    },
    closeModalEditVehicle(vehicle) {
      if (vehicle) {
        this.saveVehicle(vehicle);
      }

      this.isModalEditVehicleOpen = false;
    },
    saveClient(client) {
      this.$store.dispatch('ServiceOrder/saveClient', client);
    },
    saveVehicle(vehicle) {
      this.$store.dispatch('ServiceOrder/saveVehicle', vehicle);
    },
    openWhatsapp(phone) {
      window.open(`whatsapp://send?phone=55${phone.match(/\d+/g).join('')}`);
    },
    openMaps(coordinates) {
      window.open(`http://www.google.com/maps/place/${coordinates}`);
    },
    handleOpenAddClient() {
      this.isModalManageClientOpen = true;
    },
    handleOpenAddVehicle() {
      this.isModalManageVehicleOpen = true;
    }
  }
};
</script>

<style lang="scss">
.service-client {
  .yeep-table {
    width: 100%;
    border: 2px solid #bebebe;
    font-size: 18px;
    border-radius: 5px;
    text-transform: uppercase;

    &.normal-text {
      text-transform: none;
    }

    tr {
      text-align: center;

      td {
        border: 1px solid #d9d9d9;
        padding: 4px 8px;
        border-radius: 5px;

        &.text-left {
          text-align: left !important;
        }
      }
    }
  }

  .vehicle-brand {
    margin: 0 auto;
    height: 50px;
    width: 100px;
    content: '';
    background-size: contain;
    background-position: center;
  }

  .plate-content {
    align-items: center;
    display: flex;
    justify-content: center;

    .plate {
      margin: 0 auto;
      text-align: center;
      background-color: #fff;
      background-image: linear-gradient(170deg, #fff 60%, #ddd);
      border-radius: 6px;
      color: #222;
      display: inline-block;
      font-family: monospace;
      font-size: 52px;
      font-weight: 900;
      padding: 17px 15px 0;
      position: relative;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      overflow: hidden;
      background: repeating-linear-gradient(135deg, #222, #222 8px, #666 8px, #666 12px);

      &:before,
      &:after {
        content: '';
        position: absolute;
        box-sizing: border-box;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      &:before {
        z-index: -2;
        background-image: inherit;
      }

      &:after {
        margin: 4px;
        background-color: #fff;
        border-radius: 6px;
      }

      span {
        position: relative;
        background: repeating-linear-gradient(135deg, #222, #222 8px, #666 8px, #666 12px);
        -webkit-text-fill-color: transparent;
        z-index: 1;

        &:before {
          background-color: #00f;
          color: #fff;
          content: 'brasil';
          font-size: 0.35em;
          position: absolute;
          text-align: center;
          top: -21px;
          left: -11px;
          right: -11px;
          border-radius: 6px 6px 0 0;
          overflow: visible;
          -webkit-text-fill-color: #fff;
        }
      }
    }
  }

  .client-evaluation {
    table {
      width: 100%;
    }
  }
}
</style>
